<template>
    <div class="directInitiation">
        <div>
            <div class="contractTitle">
                <div style="width: 5px;height: 18px;background-color: #409EFF"></div>
                <p>合同基本信息</p>
            </div>
            <div class="contractContent">
                <div class="contractName">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                        <el-form-item  label="合同名称" style="display: flex">
                            <el-input v-model="ruleForm.doc_title" placeholder="请输入合同名称" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="合同编号" style="display: flex">
                            <el-input v-model="ruleForm.contract_sn" placeholder="不填系统会自动生成"></el-input>
                        </el-form-item>
                        <el-form-item   label="签署截止时间" style="display: flex" prop="time">
                            <el-date-picker
                                style="width: 200px"
                                v-model="time"
                                :clearable="false"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item  label="支付金额" style="display: flex" prop="money">
                            <el-input v-model="ruleForm.money" placeholder="请输入支付金额" :disabled="identity.mode==2"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="signatoryBox">
            <div class="signatory">
                <div style="width: 5px;height: 18px;background-color: #409EFF"></div>
                <p>设置签署方</p>
            </div>
            <div class="participateBox" >
                <div class="payer">支付方</div>
                <div class="participate">参与主体</div>
                <div class="keyWord">签署关键字</div>
                <div class="signed">签署方信息</div>
                <div class="operation">操作</div>
            </div>
            <div class="signatoryList" v-for="(item,index) in signatoryForm" :key="index">
                <div class="payerBox">
                    <el-radio-group v-model="selectedPayerIndex">
                        <el-radio  :label="index" @change="setPayer(index)">{{''}}</el-radio>
                    </el-radio-group>
                </div>
                <div class="choose" >
                    <el-select v-model="item.zt_type" placeholder="请选择" style="width: 100px">
                        <el-option label="企业" value="1"></el-option>
                        <el-option label="个人" value="2"></el-option>
                    </el-select>
                </div>
                <div class="signKey">
                    <el-input v-model="item.keyword" disabled class="mainBody" placeholder="请输入签署关键字" style="width: 150px"></el-input>
                </div>
                <div class="information">
                    <el-input v-model="item.name" class="mainBody" placeholder="请输入真实姓名"></el-input>
                    <el-input v-model="item.mobile" class="mainBody" placeholder="请输入手机号"></el-input>
                    <el-input v-model="item.com_name" class="mainBody" placeholder="请输入企业完整名称" v-if="item.zt_type==1"></el-input>
                </div>
                <div class="operate">
                    <el-button type="danger" @click="removeBtn(index)">删除</el-button>
                </div>
            </div>
            <el-button type="primary" @click="addSign">添加签署方</el-button>
        </div>
        <p style="margin: 15px 0;color: #525961"><span style="color: red">注意：</span>请先在word版的合同文件中按照上方生成的签署关键字，在需要签署方盖章或签字的位置设置好对应的签署关键字。
            同一个签署方如需在多处盖章或签字，请在对应的多处位置设置成签署方对应的同一个签署关键字即可。
            最后请将所有签署关键字都设置成不可见的白色字体，然后将word文件转成pdf文件上传即可。
            如未配置签署关键字或配置的签署关键字与签署方不一致将无法发起合同签署。</p>
        <!--     上传签署文件   -->
        <div class="uploadBox">
            <div class="uploadTitle">
                <div style="width: 5px;height: 18px;background-color: #409EFF"></div>
                <p>上传签署文件</p>
            </div>
            <div class="matter">
                <div class="fileContent">
                    <p style="color: #525961">签署文件:</p>
                </div>
                <el-upload
                    ref='upload'
                    :limit="1"
                    class="inline"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {applicationRemove(file, fileList)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="application"
                >
                    <el-button class="custom">
                        上传
                    </el-button>
                </el-upload>
            </div>
        </div>
        <el-button style="display: block;margin: auto" type="primary" @click="submitBtn">发起合同</el-button>
    </div>
</template>

<script>
import { directInitiation_pay } from '@/api/initiation';
import bus from '@/components/common/bus';

export default {
    name: 'directInitiation_pay',
    data(){
        return{
            url:process.env.VUE_APP_BASE_API+'/api/upload_direct_file',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Comid': sessionStorage.getItem('shenfen'),
                "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
            },
            selectedPayerIndex: null, // 新增变量，用于存储当前选中的支付者索引
            ruleForm:{
                doc_title:'',
                contract_sn:'',
                money:'',
            },
            identity:'',
            rules:{
                doc_title: [
                    { required: true, message: '请输入合同名称', trigger: 'blur' }
                ],
                // time:[
                //     { required: true, message: '签署截止时间不能为空', trigger: 'blur' }
                // ],
                money: [
                    { required: true, message: '请输入支付金额', trigger: 'blur' }
                ]
            },
            time:'',
            signatoryForm:[
                {
                    is_payer:0,
                    zt_type:'1',
                    keyword:'sign0001',
                    name:'',
                    mobile:'',
                    com_name:'',
                }
            ],
            fileId:'',
            upload_data:{

            },
            application:[],

        }
    },
    methods:{
        GetDateStr(date) {
            var dd = new Date();
            dd.setDate(dd.getDate() + date);//获取AddDayCount天后的日期
            var y = dd.getFullYear();
            var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
            var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
            return y + "-" + m + "-" + d;
        },
        // 删除
        removeBtn(index){
            if (this.signatoryForm.length==1){
                this.$message.error('至少保留一个签署方')
            }else {
                if (this.selectedPayerIndex === index) {
                    // 如果删除的是当前选中的支付方，将 selectedPayerIndex 设为 null
                    this.selectedPayerIndex = null;
                } else if (this.selectedPayerIndex > index) {
                    // 如果删除的是选中支付方之前的元素，将 selectedPayerIndex 减 1
                    this.selectedPayerIndex--;
                }

                this.signatoryForm.splice(index,1)
                this.signatoryForm.forEach((item,index)=>{
                    item.keyword=`sign${String(index+1).padStart(4,'0')}`
                })
            }
        },
        // 添加
        addSign(){
            if (this.signatoryForm.length>=10){
                this.$message.error('最多添加10个签署方')
            }else {
                const nextNum=this.signatoryForm.length+1
                this.signatoryForm.push({
                    is_payer:0,
                    zt_type:'1',
                    keyword:`sign${String(nextNum).padStart(4,'0')}`,
                    name:'',
                    mobile:'',
                    com_name:'',
                })
            }
        },
        //点击文件列表事件
        handlePreview(file){
            if (file.all_url){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.all_url);
            }else if (file.response){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.response.data.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.response.data.all_url);
            }
        },
        applicationRemove(){

        },
        //上传成功
        handleSuccess(response, file, fileList){
            if (response.code == 200){
                this.fileId = response.data.fileId
                this.ruleForm.doc_title = response.data.doc_title;
            }else {
                this.$message.error(response.msg);
            }
        },
        //限制上传个数
        handleExceed(files, fileList){
            if (fileList.length>=1){
                this.$message.error('只能上传1个文件');
            }
        },
        setPayer(index) {
            // 先将所有签署方的 is_payer 设为 0
            this.signatoryForm.forEach(item => item.is_payer = 0);
            // 将当前选中的签署方的 is_payer 设为 1
            this.signatoryForm[index].is_payer = 1;
        },
        // 发起合同
        submitBtn(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    for (const item of this.signatoryForm){
                        if(!item.name) return this.$message.error('请填写姓名')
                        if(!item.mobile) return this.$message.error('请填写手机号')
                        if(item.zt_type == 1 && !item.com_name) return this.$message.error('请填写企业名称')
                    }
                    const hasPayer = this.signatoryForm.some(item => item.is_payer === 1);
                    if (!hasPayer) {
                        this.$message.error('请设置支付方');
                        return;
                    }
                    if(!this.fileId) return this.$message.error('请先上传签署文件')
                    let data={
                        doc_title:this.ruleForm.doc_title,
                        contract_sn:this.ruleForm.contract_sn,
                        money:this.ruleForm.money,
                        expire_time:this.time,
                        signers:this.signatoryForm,
                        fileId:this.fileId
                    }

                    this.$confirm('请确认是否发起合同 ', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        directInitiation_pay(data).then(res=>{
                            if (res.code==200){
                                this.$message.success(res.msg)
                                bus.$emit('close_current_tags')
                                this.$router.push({path:'/orderList'})
                            }else {
                                this.$message.error(res.msg)
                            }
                        })
                    }).catch(() => {

                    });

                } else {
                    return false;
                }
            });

        }
    },
    created() {
        this.identity=JSON.parse(sessionStorage.getItem('shenfen'))
        this.ruleForm.money=this.identity.money;
        this.headers.Comid = JSON.parse(sessionStorage.getItem('shenfen')).com_id;
        this.time=this.GetDateStr(89)
        if (this.signatoryForm.length > 0) {
            this.selectedPayerIndex = 0;
            this.setPayer(0);
        }
    }
}
</script>

<style scoped>
    .directInitiation{
        background-color: #ffffff;
        padding: 20px;
        border-radius: 5px;
    }
    .contractTitle{
        display: flex;
        align-items: center;
    }
    .contractTitle>p{
        margin-left: 10px;
    }
    .contractContent{
        margin: 10px 0px;
        overflow: hidden;
        color: #333333;
    }
    .contractName{
        display: flex;
        margin: 10px 0px;
        align-items: center;
    }
    .contractCopies>p{
        margin-left: 10px;
    }
    ::v-deep .el-form-item__label{
        width: 120px;
    }
    .signatory{
        display: flex;
        align-items: center;
    }
    .signatory>p{
        margin-left: 10px;
    }
    .participateBox{
        display: flex;
        align-items: center;
        height: 50px;
        background-color: #f3f3f9;
        color: #525961;
        padding: 0px 20px;
        margin: 20px 0;
    }
    .payer{
        width: 10%;
    }
    .participate{
        width: 10%;
    }
    .keyWord{
        width: 15%;
    }
    .signed{
        width: 55%;
    }
    .operation{
        width: 10%;
    }
    .signatoryList{
        display: flex;
        margin: 20px 0px;
        padding: 0 20px;
    }
    .payerBox{
        width: 10%;
    }
    ::v-deep .el-radio-group{
        margin-left: 15px;
    }
    .choose{
        width: 10%;
    }
    .signKey{
        width: 15%;
    }
    .information{
        width: 55%;
        display: flex;
    }
    .operate{
        width: 10%;
    }
    .mainBody{
        margin-right: 10px;
    }
    .uploadTitle{
        display: flex;
        align-items: center;
    }
    .uploadTitle>p{
        margin-left: 10px;
    }
    .uploadBox{
        margin: 20px 0;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 20px;
    }

    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    ::v-deep .el-upload--text{
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .preserve>button{
        background-color: #409EFF;
        color: #ffffff;
    }

    .custom{
        background-color: #409EFF;
        color: #fff;
    }
    ::v-deep .el-upload-list__item{
        margin-top: 0;
    }
</style>